[
    "abalone",
    "acetat",
    "acetyliertes hydriertes schweineschmalzglyzerid",
    "acetyliertes lanolin",
    "acetylierter lanolinalkohol",
    "acetyliertes lanolinricinoleat",
    "acetylierter talg",
    "acidophilus-milch",
    "adrenalin",
    "nebennieren von rindern",
    "nebennieren von schweinen",
    "nebennieren von schafen",
    "nachgeburt",
    "alanin",
    "alcloxa",
    "aliphatischer alkohol",
    "alligator",
    "alligatorhaut",
    "alpha-hydroxysäuren",
    "ambra",
    "amerachol",
    "amerchol l101",
    "aminiuccinatsäure",
    "ammoniumkaseinat",
    "fruchtwasser",
    "ampd isoterisches hydrolysiertes tierprotein",
    "amylase",
    "sardellen",
    "sardelle",
    "angora",
    "tierknochen",
    "tierkollagen-aminosäuren",
    "tierfett",
    "tierfette",
    "tierfette und -öle",
    "tierhaare",
    "tierkeratin-aminosäuren",
    "tieröl",
    "tieröle",
    "tierplazenta",
    "tierproteinderivat",
    "tiergewebeextrakt",
    "arachidonsäure",
    "arachidylpropionat",
    "astrachan",
    "rückenspeck",
    "rückenfett",
    "speck",
    "barsch",
    "batylalkohol",
    "batylisosteareat",
    "bär",
    "bienenpollen",
    "bienenprodukte",
    "rindfleisch",
    "rinderherz",
    "rinderleber",
    "rinderzunge",
    "bienenpollen",
    "bienenwachs",
    "bienenwachswabe",
    "bauchspeck",
    "benzyltrimonium hydrolysiertes tierprotein",
    "bison",
    "blut",
    "blutplasmafraktionierung",
    "blutzunge",
    "wildschweinborsten",
    "gekochter schinken",
    "knochenasche",
    "knochenkohle",
    "knochenkohle/knochenschwarz",
    "knochenkohle",
    "knochenerde",
    "knochenmehl",
    "knochenphosphat",
    "knochensuppe",
    "knochen/knochenmehl",
    "knochenschwarz",
    "knochenmehl",
    "bonito",
    "rinderserumalbumin",
    "gehirnextrakt",
    "bratwurst",
    "sülze",
    "frühstücksspeck",
    "bresaola",
    "brühwurst",
    "brühwurst",
    "büffel",
    "büffelmilch",
    "wildfleisch",
    "butter",
    "butterfett",
    "butterfestteile",
    "buttermilch",
    "buttermilchpulver",
    "c30-46 fischöl",
    "tintenfisch",
    "calciferol",
    "calciferool",
    "kalziumkaseinat",
    "kalbsleber",
    "kalbshaut",
    "kalbshautextrakt",
    "kamelmilch",
    "kanadischer speck",
    "cantharidin",
    "kantharidenstinktur",
    "capiz",
    "caprylsäuretriglyzerid",
    "carbamid",
    "karibu",
    "karmin",
    "karmin cochenille karminsäure",
    "karmin/karminsäure",
    "karmin",
    "karminsäure",
    "karotin",
    "karotin provitamin a beta-karotin",
    "karpfen",
    "kasein",
    "kasein kaseinat",
    "kaseinat",
    "kaseinogen",
    "kaschmir",
    "biber",
    "biber bibergeil",
    "bibergeil",
    "wels",
    "katgut",
    "catharidin",
    "kaviar",
    "kaviar(e)",
    "kaviar",
    "cera flava",
    "cerebroside",
    "ceteth",
    "ceteth-02",
    "ceteth-1",
    "ceteth-10",
    "ceteth-2",
    "ceteth-30",
    "ceteth-4",
    "ceteth-6",
    "cetyllaktat",
    "cetylmyristat",
    "chamois",
    "käse",
    "huhn",
    "hähnchenbrust",
    "hühnerleber",
    "hühnerrollbraten",
    "gehackter schinken",
    "chitosan",
    "cholesterin",
    "cholesterol",
    "cholinbitartrat",
    "chondroitin",
    "gehackter schinken",
    "chorizo",
    "chymotrypsin",
    "geklärte butter",
    "geronnene sahne",
    "cochenille",
    "kabeljau",
    "lebertran",
    "aufschnitt",
    "coleth-24",
    "kollagen",
    "kollagenhydrolysat",
    "kondensmilch",
    "konfektglasur",
    "gekochter schinken",
    "gekochtes fleisch",
    "koralle",
    "corned beef",
    "kornisches rebhuhn",
    "kortikosteroid",
    "kortikosteroid",
    "cortison kortikosteroid",
    "cotechino",
    "hüttenkäse",
    "krabbe",
    "krabbenfleisch",
    "flusskrebs",
    "flusskrebs",
    "sahne",
    "krustentiere",
    "quark",
    "pudding",
    "cystein, l-form",
    "cystin",
    "dunkles fleisch",
    "dashi",
    "dea-oleth-10 phosphat",
    "hirsch",
    "hirschfleisch",
    "entlaktosierte molke",
    "feinkost",
    "entmineralisierte molke",
    "desoxyribonukleinsäure",
    "desamidiertes tierkollagen",
    "desamidiertes kollagen",
    "desamidocollagen",
    "devon",
    "dicaprylsäurecystin",
    "diethylentrikaseinamid",
    "dihydrocholesterol",
    "dihydrocholesteroloctyledekanoat",
    "dihydrocoleth-15",
    "dihydrocoleth-30",
    "dihydriertes talgbenzylmoniumchlorid",
    "dihydriertes talgmethylamin",
    "dihydriertes talgphthalat",
    "dihydroxyethyltalgaminoxid",
    "dimethylhydriertes talgamin",
    "dimethylstearamin",
    "dimethyltalgamin",
    "dinatriumhydriertestalgglutamat",
    "dinatriumhydriertestalgglutamat",
    "dinatriumtallamido mea-sulfosuccinat",
    "dinatriumtallowaminodipropionat",
    "ditallowdimoniumchlorid",
    "dns",
    "daunen",
    "trockene buttermilch",
    "trockenes eigelb",
    "trockenmilchfeststoffe",
    "trockenvollmilch",
    "ente",
    "entenspeck",
    "entenleber",
    "duodenumsubstanzen",
    "holländischer käse",
    "farbstoffe",
    "e120",
    "e441",
    "e542",
    "e904",
    "e913",
    "essbares knochenphosphat",
    "ei",
    "eialbumin",
    "eialbumin/albumin",
    "eialbumin",
    "eiöl",
    "eipulver",
    "eiprotein",
    "eiweiß",
    "eigelb",
    "eigelbextrakt",
    "eigelb",
    "eier",
    "eiderdunen",
    "elastin",
    "elchspeck",
    "embryoextrakt",
    "emu",
    "emuöl",
    "epiderm öl r",
    "ergisterol",
    "ergosterol",
    "estradiolbenzoat",
    "östrogen",
    "östrogen estradiol",
    "östrogen/estradiol",
    "estron",
    "ethylarachidonat",
    "ethylester von hydrolysiertem tierprotein",
    "ethyllipineat",
    "ethylmorrhuatlipineat",
    "ethylmorrhuatelipineat",
    "ethylarachidonat",
    "ethylendehydriertestalgamid",
    "kondensmilch",
    "schafsmilch",
    "fettfreie milch",
    "fettfreier joghurt",
    "fettsäuren",
    "federn",
    "fermentierte kamelmilch",
    "fermentierte sahne",
    "fermentierte milch",
    "fisch",
    "fischglyzeride",
    "fischleber",
    "fischleberöl",
    "fischlebern",
    "fischöl",
    "fischsauce",
    "fischschuppen",
    "fischsauce",
    "heilbuttöl",
    "fell",
    "gel",
    "gelatine",
    "gelatinegel",
    "gelatine(e)",
    "gelatine",
    "gelbwurst",
    "ghee",
    "mägen",
    "glukosetyrosinase",
    "glukuronsäure",
    "glyzeride",
    "glyzerin glyzerin",
    "glyzerin",
    "glyzeryllanolat",
    "glyzeryle",
    "glykol",
    "glycreth-26",
    "ziege",
    "ziegenkäse",
    "ziegenmilch",
    "gans",
    "gänseisolierfedern",
    "gänseleber",
    "hackfleisch",
    "auerhuhn",
    "guanin",
    "guaninperlmuttessenz",
    "guanin/perlmuttessenz",
    "perlhuhn",
    "zigeuner speck",
    "schellfisch",
    "schweinehaare",
    "heilbutt",
    "schinken",
    "schinken-käse-laib",
    "sülze",
    "schwere sahne",
    "heptylundekanol",
    "leder",
    "lederkleber",
    "homogenisierte milch",
    "honig",
    "wabe",
    "pferd",
    "pferdehaar",
    "pferdefleisch",
    "rosshaar",
    "schweinehaar",
    "hotdog",
    "menschliches plazentalprotein",
    "menschlicher nabelschnurextrakt",
    "hyaluronsäure",
    "hydrolysiertes menschliches plazentalprotein",
    "hydriertes tierglyzerid",
    "hydriertes ditalgamin",
    "hydriertes ditallagmin",
    "hydrierter honig",
    "hydriertes laneth-20",
    "hydriertes laneth-25",
    "hydriertes laneth-5",
    "hydriertes lanolin",
    "hydrierter lanolinalkohol",
    "hydriertes schweineschmalzglyzerid",
    "hydriertes haifischleberöl",
    "hydriertestalgsäure",
    "hydriertestalgbetain",
    "hydriertestalgglyzerid",
    "hydrolysiertes tierelastin",
    "hydrolysiertes tierkeratin",
    "hydrolysiertes tierprotein",
    "hydrolysiertes kasein",
    "hydrolysiertes elastin",
    "hydrolysiertes menschliches plazentalprotein",
    "hydrolysiertes keratin",
    "hydrolysiertes milchprotein",
    "hydrolysierte seide",
    "hydroxyliertes lanolin",
    "eiscreme",
    "imidazolidinylurea",
    "eisenkaseinat",
    "hausenblase",
    "isobutyliertes lanolin",
    "isopropyllanolat",
    "isopropyltallowatelisopropylanolat",
    "isopropylpalmitat",
    "isopropylpalmitat",
    "isostearinhydrolysiertes tierprotein",
    "isostearoylhydrolysiertes tierprotein",
    "jagdwurst",
    "backe",
    "känguru",
    "katsuobushi",
    "katsuobushi (okaka)",
    "keratin",
    "keratinaminosäuren",
    "l-cystein",
    "l-cysteinhydrochlorid",
    "l-form",
    "laktosereduzierte milch",
    "laktalbumin",
    "milchsäure aus molke",
    "milchsäurehefen",
    "milchsäure",
    "laktoferrin",
    "laktoglobulin",
    "laktose",
    "laktosefreie milch",
    "laktulose",
    "lamm",
    "lammspeck",
    "laneth",
    "laneth-10",
    "laneth-11",
    "laneth-12",
    "laneth-13",
    "laneth-14",
    "laneth-15",
    "laneth-16",
    "laneth-17",
    "laneth-18",
    "laneth-19",
    "laneth-20",
    "laneth-21",
    "laneth-22",
    "laneth-23",
    "laneth-24",
    "laneth-25",
    "laneth-26",
    "laneth-27",
    "laneth-28",
    "laneth-29",
    "laneth-30",
    "laneth-31",
    "laneth-32",
    "laneth-33",
    "laneth-34",
    "laneth-35",
    "laneth-36",
    "laneth-37",
    "laneth-38",
    "laneth-39",
    "laneth-40",
    "laneth-5",
    "laneth-6",
    "laneth-7",
    "laneth-8",
    "laneth-9",
    "laneth-9 acetat",
    "laneth10 acetat",
    "lanogen",
    "lanoinamiddea",
    "lanolin",
    "lanolinsäure",
    "lanolinsäuren",
    "lanolinalkohol",
    "lanolinalkohols",
    "lanolinlinoleat",
    "lanolinöl",
    "lanolinricinoleat",
    "lanolinwachs",
    "lanolin(e)",
    "lanolin",
    "lanolin: lanolinsäure",
    "lanoinamiddea",
    "lanosterol",
    "lanosterole",
    "schmalz",
    "schweineschmalzglyzerid",
    "lauroylhydrolysiertes tierprotein",
    "leder",
    "lecithincholinbitartrat",
    "lecithincholinbitartrat",
    "lipase",
    "leber",
    "leberextrakt",
    "leberwurst",
    "hummer",
    "fettarme milch",
    "fettarmer joghurt",
    "mondschwamm",
    "mondschwamm",
    "mittagslaib",
    "mittagsfleisch",
    "mittagsfleisch",
    "makrele",
    "magnesiumkaseinat",
    "magnesiumlanolat",
    "magnesiumtallowat",
    "malzmilch",
    "mammaextrakt",
    "meeresöl",
    "marksuppe",
    "mayonnaise",
    "mea-hydrolysiertes tierprotein",
    "fleisch",
    "fleischlaib",
    "fleischbällchen",
    "mechanisch getrenntes huhn",
    "menhaden-öl",
    "methionin",
    "mettwurst",
    "milch",
    "milchschokolade",
    "milchderivat",
    "säugetiermilch",
    "milchpulver",
    "milchprotein",
    "milchhaut",
    "milchzucker",
    "milchfett",
    "milchpulver",
    "hackfleisch",
    "hackfleisch",
    "nerzöl",
    "minkamidopropyldieylamin",
    "mohair",
    "weichtiere",
    "seeteufel",
    "elch",
    "mortadella",
    "mossbunkeröl",
    "mukopolysaccharide",
    "meeräsche",
    "muskelextrakt",
    "moschus ambrette",
    "muschel",
    "muscheln",
    "hammel",
    "myristinsäure",
    "myristoylhydrolysiertes tierprotein",
    "myristyl",
    "myristyle",
    "natürlicher buttergeschmack",
    "natürlichrot 4",
    "hals",
    "magermilch",
    "nougat",
    "ocenol",
    "tintenfisch",
    "okaka",
    "oleamidopropyldimethylaminhydrolysiertes tierprotein",
    "oleostearin",
    "oleostearin",
    "oleoylhydrolysiertes tierprotein",
    "oleths",
    "oleylarachidat",
    "oleylbetain",
    "oleylimidazolin",
    "oleyllanolat",
    "oleyloleat",
    "oleylstearat",
    "oleylalkohol ocenol",
    "oleylimidazolin",
    "omega-3-fettsäuren",
    "opossum",
    "organfleisch",
    "organfleisch",
    "organe",
    "strauß",
    "ovalbumin",
    "eierstockextrakt",
    "ochsengalle",
    "ochsengalle",
    "ochsengalle",
    "auster",
    "austern",
    "palmitoylhydrolysiertes milchprotein",
    "palmitoylhydrolysiertes tierprotein",
    "pancetta",
    "parakasein",
    "rebhuhn",
    "pasteurisierte milch",
    "perle",
    "perlmuttessenz",
    "peg-13 hydriertes talgamid",
    "peg-15 talgpolyamin",
    "peg-2 milchfeststoffe",
    "peg-20 tallowat",
    "peg-28 glyzerintallowat",
    "peg-75 lanolinöl und -wachs",
    "peg-8 hydrierte fischglyzeride",
    "pentahydrosqualen",
    "pepsin",
    "perhydrosqualen",
    "pharmazeutische glasur",
    "fasan",
    "picknickschulter",
    "schweinehautextrakt",
    "plazenta",
    "plazentalpolypeptidprotein",
    "plazentalenzyme",
    "plazentalextrakt",
    "plazentalprotein",
    "scholle",
    "pogy-öl",
    "pollack",
    "polyethylen",
    "polyethylencetylether",
    "polyglyzerol",
    "polyglyceryl-2 lanolinalkoholether",
    "polypeptidprotein",
    "schweinepankreas",
    "schwein",
    "schweinefett",
    "schweinerollbraten",
    "kaliumkaseinat",
    "kaliumtallowat",
    "kaliumundecylenoylhydrolysiertes tierprotein",
    "geflügel",
    "ppg-12-peg-50 lanolin",
    "ppg-2 methylether",
    "ppg-5-ceteth-20",
    "ppg-10",
    "ppg-20 methylglukoseether",
    "ppg-30 cetylether",
    "ppg-30 lanolinether",
    "garnele",
    "pregnenolonacetat",
    "pristan",
    "propolis",
    "prosciutto",
    "provitamin a",
    "purcellinöl syn",
    "wachtel",
    "quaternium 27",
    "kaninchen",
    "rotes fleisch",
    "fettreduzierte milch",
    "fettreduzierter joghurt",
    "labkasein",
    "harzglasur",
    "retikulin",
    "retinol",
    "roastbeef",
    "schweinebraten",
    "rogen",
    "gelée royale",
    "zobel",
    "zobelpinsel",
    "saccharidisomerat",
    "salami",
    "salceson",
    "lachs",
    "sardine",
    "wurst",
    "würste",
    "jakobsmuschel",
    "jakobsmuscheln",
    "meeresschwamm",
    "meeresschildkrötenöl",
    "meeresschwamm",
    "serumalbumin",
    "serumproteine",
    "haifischleberöl",
    "haifischleberöl",
    "schafsmilch",
    "schafshaut",
    "schafsfell",
    "schellack",
    "schellackharzglasur",
    "schellackwachs",
    "schulter",
    "garnele",
    "shrimph",
    "seitenspeck",
    "seide",
    "seidenaminosäuren",
    "seidenpulver",
    "seidenpulver",
    "magermilch",
    "haut",
    "plattenspeck",
    "aufgeschnittenes fleisch",
    "geräucherter schinken",
    "schnecke",
    "schnecken",
    "schlange",
    "schnapper",
    "natrium / tea-lauroylhydrolysiertes tierprotein",
    "natrium / tea-undecylenoylhydrolysiertes tierprotein",
    "natriumkaseinat",
    "natrium coco-hydrolysiertes tierprotein",
    "natrium soja hydrolysiertes tierprotein",
    "natriumtalgsulfat",
    "natriumtallowat",
    "natriumundecylenat",
    "natriumstearoyllactylat",
    "natriumstearoyllactylat",
    "lösliches kollagen",
    "saure sahne",
    "sauermilch",
    "sauermilchfeststoffe",
    "sauermilch",
    "sojahydroxyethylimidazolin",
    "walratöl",
    "pottwaldärme",
    "walrat",
    "walratcetylpalmitat walratöl",
    "milzextrakt",
    "schwamm (mond und meer)",
    "täubchen",
    "tintenfisch",
    "eichhörnchen",
    "steak",
    "stearyldimethylamin",
    "steroide sterole",
    "sterole",
    "schmorfleisch",
    "stilton",
    "durchwachsener speck",
    "süße molke",
    "süße molke",
    "kalbsbries",
    "gezuckerte kondensmilch",
    "schwertfisch",
    "talg",
    "talgsäure",
    "talgamid",
    "talgamin",
    "talgaminoxid",
    "talgaminopropylamin",
    "talgfettalkohol",
    "talgglyzeride",
    "talghydroxyethylimidazolin",
    "talgimidazolin",
    "talgtrimoniumchlorid - talg",
    "tallowamidopropylaminoxid",
    "talloweth-6",
    "tallowmiddea",
    "tallowmiddea und mea",
    "tallowmidmea",
    "tallowmidopropylhydroxysultain",
    "tallowminopropylamin",
    "tallowmphoacet",
    "tea-abietoylhydrolysiertes tierprotein",
    "tea-coco hydrolysiertes tierprotein",
    "tea-lauroyl tierkollagen-aminosäuren",
    "tea-lauroyl tierkeratin-aminosäuren",
    "tea-myristol hydrolysiertes tierprotein",
    "tea-undecylenoyl hydrolysiertes tierprotein",
    "hodenextrakt",
    "thüringer wurst",
    "tilapia",
    "zunge",
    "triethoniumhydrolysiertes tierproteinethosulfat",
    "trilaneth-4phosphat",
    "kutteln",
    "triterpenalkohole",
    "forelle",
    "trypsin",
    "thunfisch",
    "truthahn",
    "putenschinken",
    "putenbrust",
    "schildkröte",
    "schildkrötenöl",
    "meeresschildkrötenöl",
    "tyrosin",
    "nicht homogenisierte milch",
    "harnstoff",
    "harnstoffcarbamid",
    "harnsäure",
    "harnsäure von kühen",
    "harnsäure",
    "urin",
    "kalb",
    "kalbsbraten",
    "hirsch",
    "vitamin d ergocalciferol vitamin d",
    "vitamin h",
    "vitaminb",
    "vitaminb-faktor",
    "volaise",
    "molke",
    "molkenpulver",
    "molkenprotein",
    "schlagsahne",
    "schlagcreme",
    "weißes fleisch",
    "vollmilch",
    "vollmilchjoghurt",
    "wildschwein",
    "wildfleisch",
    "wolle",
    "wollfett",
    "wollwachs",
    "wollwachsalkohole",
    "joghurt",
    "joghurt",
    "zinkkaseinat",
    "zinkhydrolysiertes tierprotein"
]